import Banner from "@/components/pages/home/banner";
import HowWeDo from "@/components/pages/home/how-we-do";
import WhatWeDo from "@/components/pages/home/what-we-do";
import Section from "@/components/ui/section";
import Team from "@/components/pages/home/team";
import { leadership } from "@/data/team";
import ContactUsSection from "@/components/pages/home/contact-us";
import WhereWeWork from "@/components/pages/home/where-we-work";
export default function Home() {
  return (
    <>
      {/* <div className="w-full h-screen flex flex-col items-center justify-center">
        <Logo size="md:w-[245px] md:h-[87px] w-[200px] h-[60px] mx-auto" />
        <div className="flex flex-col items-center justify-center bg-white text-center px-4 mt-4">
          <h1 className="text-2xl md:text-5xl font-bold text-black">
            Our website is currently undergoing maintenance.
          </h1>
          <p className="text-xl md:text-2xl font-semibold mt-4">
            For assistance, please contact us at:{" "}
            <a
              href="mailto:info@dignityallianceinternational.org"
              className="text-blue hover:text-darkBlue"
            >
              info@dignityallianceinternational.org
            </a>
          </p>
        </div>
      </div> */}
      <Banner />
      <Section variant="flat">
        <h1 className="lg:max-w-[800px] mx-auto py-12 px-4 text-white bg-darkBlue rounded-[20px] lg:text-lg md:text-base text-sm text-center">
          <strong className="text-blue">Dignity Alliance International</strong>{" "}
          is a UK-based charity dedicated to empowering vulnerable communities,
          with a particular focus on women and girls, by supporting
          community-led solutions that foster resilience and sustainable
          development across Asia.
        </h1>
      </Section>
      <WhatWeDo
        id="what-we-do"
        title="What We Do"
        image="/images/dai-map.webp"
        content={
          <>
            <p>
              DAI invests in transformative initiatives that expand educational
              and economic opportunities for women and girls, advance gender
              equality, and strengthen community resilience against social and
              economic challenges.
            </p>
            <p>
              The organization champions community-led solutions focused on
              financial inclusion, insurance access, worker welfare, safe
              migration, social protection, and community adaptation and
              resilience. By prioritizing locally driven approaches, DAI ensures
              that every initiative is rooted in local realities, responsive to
              community needs, and sustainable for future generations.
            </p>
            <p>
              Working closely with grassroots organizations, DAI amplifies
              community voices and equips them with the resources, knowledge,
              and networks needed to drive meaningful and lasting change.
            </p>
          </>
        }
      />
      <WhereWeWork />
      <HowWeDo />
      {/* <Reports /> */}
      <Team title="Managing Board" data={leadership} className="bg-[#F4F9FF]" />
      <ContactUsSection />

      {/* <TrackedLink href="https://www.dignityallianceinternational.org/pdfs/OnTheirOwnTerms.pdf" target="_blank" rel="noreferrer">
  Download report
</TrackedLink> */}
    </>
  );
}
